import Yup from '_zari/validation/_yup'

const validationSchema = Yup.object().shape({
  flagFiltrosAvanzados: Yup.bool().required(),
  fechaDesde: Yup.string().when('flagFiltrosAvanzados', {
    is: false,
    then: Yup.string().required()
  }),
  fechaHasta: Yup.string().when('flagFiltrosAvanzados', {
    is: false,
    then: Yup.string().required()
  }),
  tipoDocumento: Yup.string().notRequired(),
  estado: Yup.string().notRequired(),
  serieDocumento: Yup.string().when('flagFiltrosAvanzados', {
    is: true,
    then: Yup.string().required()
  }),
  numeroDocumento: Yup.number().when('flagFiltrosAvanzados', {
    is: true,
    then: Yup.number().required()
  }),
  ruc: Yup.string().notRequired(),
  razonSocial: Yup.string().notRequired()
})

export default validationSchema
